export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        email: entity.email || '',
        permissions: entity.permissions || {}
    };
};
